import { Injectable } from '@angular/core';

import { BetBuilderProvider } from '@cds/betting-offer/add-ons';
import { EventDetailsConfig } from '@frontend/sports/common/client-config-data-access';
import { LocalStoreService } from '@frontend/vanilla/core';

@Injectable({
    providedIn: 'root',
})
export class EventHeaderTabsTooltipService {
    private localKey: string;
    private openTillClosed = false;

    private get tooltipShownCount() {
        return this.localStoreService.get<number>(this.localKey) ?? 0;
    }

    constructor(
        private eventDetailsConfig: EventDetailsConfig,
        private localStoreService: LocalStoreService,
    ) {}

    shouldShowTooltip(provider?: BetBuilderProvider): boolean {
        switch (provider) {
            case BetBuilderProvider.Angstrom:
                this.localKey = 'tab-bar-tooltip-count-angstrom';
                break;
            case BetBuilderProvider.BybFootball:
                this.localKey = 'tab-bar-tooltip-count-byb';
                this.openTillClosed = true;
                break;
            default:
                this.localKey = 'tab-bar-tooltip-count';
        }

        return this.tooltipShownCount < this.eventDetailsConfig.tabBarTooltipViewsThreshold;
    }

    increaseCount(): void {
        if (!this.openTillClosed) {
            this.localStoreService.set(this.localKey, this.tooltipShownCount + 1);
        }
    }

    closeTooltip() {
        this.localStoreService.set(this.localKey, this.eventDetailsConfig.tabBarTooltipViewsThreshold + 1);
    }
}
